import { render, staticRenderFns } from "./ReferralReasonModal.vue?vue&type=template&id=c81f2e12"
import script from "./ReferralReasonModal.vue?vue&type=script&lang=js"
export * from "./ReferralReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports